// extracted by mini-css-extract-plugin
export default {"system":"StartSystem_system__OVSQH","box":"StartSystem_box__bAUAS","label":"StartSystem_label__nHU3n","values":"StartSystem_values__rXjlM","create":"StartSystem_create__8F2s1"};